import { Dispatch } from 'redux';
import { LoginService } from '../../services/LoginService';
import { donorapi } from '../../ApiNames';


export const fetchDataSuccess = (data: any) => ({
    type: 'FETCH_DATA_SUCCESS',
    payload: data,
});

export const fetchPieChartDataSuccess = (pieChartData: any, piechartOptions: any) => ({
    type: 'FETCH_PIE_CHART_DATA_SUCCESS',
    payload: { pieChartData, piechartOptions }
});

export const fetchDonorChartDataSuccess = (donorChartData: any, donorrchartOptions: any) => ({
    type: 'FETCH_Donor_CHART_DATA_SUCCESS',
    payload: { donorChartData, donorrchartOptions }
});
export const fetchTableDataSuccess = (donorTableData: any) => ({
    type: 'FETCH_Donor_Table_CHART_DATA_SUCCESS',
    payload: { donorTableData }
});
//To get list of officers data
export const fetchData = (uid: any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { userid: uid };
            const apiname = donorapi.ddashboard;
            const response = await LoginService.getData(apiname, payload);
            dispatch(fetchDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
//To get pie chart data
export const fetchPieChartData = () => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { q: 7 };
            const apiname = donorapi.dcharts;
            const response = await LoginService.getData(apiname, payload);
            if (Array.isArray(response) && response.length > 0) {
                const documentStyle = getComputedStyle(document.documentElement);
                const labels = response.map(item => item.label);
                const values = response.map(item => item.value);
                const data = {
                    // labels: ['A', 'B', 'C'],
                    labels: labels,
                    datasets: [
                        {
                            // data: response
                            data: values
                        }
                    ]
                }
                const options = {
                    plugins: {
                        legend: {
                            labels: {
                                usePointStyle: true
                            }
                        }
                    }
                };
                dispatch(fetchPieChartDataSuccess(data, options));
            }
        } catch (error) {
            console.error('Error fetching chart data:', error);
        }
    };
};
//To get bar chart data
// export const fetchDonorChartData = (uid:any) => {
//     return async (dispatch: Dispatch) => {
//         try {
//             const payload = { q: 8 ,userid:uid};
//             const apiname = donorapi.dcharts;
//             const response = await LoginService.getData(apiname,payload);
//             if (Array.isArray(response) && response.length > 0) {
//               const labels = response.map(item => item.label); 
//               const values = response.map(item => item.value);
//               const data = {
//                 labels: labels,
//                 datasets: [
//                   {
//                     label:'Months',
//                     data: 
//                       values
//                     ,
//                     backgroundColor: [
//                       'rgba(255, 159, 64, 0.2)',
//                       'rgba(75, 192, 192, 0.2)',
//                       'rgba(54, 162, 235, 0.2)',
//                       'rgba(153, 102, 255, 0.2)',
//                     ],
//                     borderColor: [
//                       'rgb(255, 159, 64)',
//                       'rgb(75, 192, 192)',
//                       'rgb(54, 162, 235)',
//                       'rgb(153, 102, 255)',
//                     ],
//                     borderWidth: 1,
//                   },
//                 ],
//               };
//               const options = {
//                 scales: {
//                   y: {
//                     beginAtZero: true,
//                   },
//                 },
//               };
//               dispatch(fetchDonorChartDataSuccess(data, options));
//             }
//           } catch (error) {
//             console.error('Error fetching chart data:', error);
//           }

//     };
// };
// Redux Action
export const fetchDonorChartData = (uid: any) => {

    return async (dispatch: Dispatch) => {

        try {

            const payload = {
                q: 8,
                userid: uid
            };

            const apiname = donorapi.dcharts;

            const response = await LoginService.getData(
                apiname,
                payload
            );

            if (
                Array.isArray(response) &&
                response.length > 0
            ) {

                const documentStyle =
                    getComputedStyle(document.documentElement);

                const labels = response.map(
                    (item) => item.label
                );

                const values = response.map(
                    (item) => item.value
                );

                const data = {

                    labels,

                    datasets: [
                        {
                            label: 'Monthly Donations',

                            data: values,

                            borderRadius: 14,

                            borderSkipped: false,

                            maxBarThickness: 55,

                            backgroundColor: [
                                '#3B82F6',
                                '#10B981',
                                '#F59E0B',
                                '#EF4444',
                                '#8B5CF6',
                                '#06B6D4',
                                '#EC4899',
                                '#14B8A6',
                                '#F97316',
                                '#6366F1',
                                '#84CC16',
                                '#E11D48'
                            ],

                            hoverBackgroundColor: [
                                '#2563EB',
                                '#059669',
                                '#D97706',
                                '#DC2626',
                                '#7C3AED',
                                '#0891B2',
                                '#DB2777',
                                '#0F766E',
                                '#EA580C',
                                '#4F46E5',
                                '#65A30D',
                                '#BE123C'
                            ]
                        }
                    ]
                };

                const options = {

                    maintainAspectRatio: false,

                    responsive: true,

                    plugins: {

                        legend: {

                            position: 'top',

                            labels: {

                                color:
                                    documentStyle.getPropertyValue(
                                        '--text-color'
                                    ),

                                usePointStyle: true,

                                padding: 20,

                                font: {
                                    size: 14,
                                    weight: '600'
                                }
                            }
                        },

                        tooltip: {

                            backgroundColor: '#111827',

                            titleColor: '#ffffff',

                            bodyColor: '#ffffff',

                            padding: 12,

                            cornerRadius: 10,

                            displayColors: true
                        }
                    },

                    scales: {

                        x: {

                            grid: {
                                display: false
                            },

                            ticks: {

                                color:
                                    documentStyle.getPropertyValue(
                                        '--text-color-secondary'
                                    ),

                                font: {
                                    size: 12,
                                    weight: '500'
                                }
                            }
                        },

                        y: {

                            beginAtZero: true,

                            grid: {

                                color: '#e5e7eb',

                                drawBorder: false
                            },

                            ticks: {

                                color:
                                    documentStyle.getPropertyValue(
                                        '--text-color-secondary'
                                    ),

                                font: {
                                    size: 12
                                }
                            }
                        }
                    },

                    animation: {

                        duration: 1800,

                        easing: 'easeOutQuart'
                    }
                };

                dispatch(
                    fetchDonorChartDataSuccess(
                        data,
                        options
                    )
                );
            }

        } catch (error) {

            console.error(
                'Error fetching chart data:',
                error
            );
        }
    };
};

export const fetchTableData = (uid: any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { userid: uid, q: 9 };
            const apiname = donorapi.dcharts;
            const response = await LoginService.getData(apiname, payload);
            dispatch(fetchTableDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};